import withStore, { TLoadingAwarePresenter, TPresentable } from "../withStore";
import { IApplicantReport } from "../../model/report/ApplicantReport";
import GetReport2DataInteractor from "../../interactor/report/GetReport2DataInteractor";
import { DateService } from "../../service/DateService";

export interface TReport2Presenter extends TLoadingAwarePresenter {
  report2PeriodFrom?: Date;
  report2PeriodTo?: Date;
  report2Min?: number;
  report2Max?: number;
  report2EvaluationStatus?: string;
  report2?: IApplicantReport[];
}

export interface IReport2Presenter extends TReport2Presenter, TPresentable {
  onPeriodFromChange(report2PeriodFrom?: Date): void;
  onPeriodToChange(report2PeriodTo?: Date): void;
  onMinChange(report2Min?: number): void;
  onMaxChange(report2Max?: number): void;
  onEvaluationStatusChange(report2EvaluationStatus?: string): void;
  getReport2PDF(): void;
  getReport2XLSXLink(): string;
}

const defaultState: TReport2Presenter = {};

const Report2Presenter = withStore<IReport2Presenter, TReport2Presenter>(
  ({ application, store, loader, translate }): IReport2Presenter => {
    const _store = store;
    const _application = application;
    const state = _store.getState<TReport2Presenter>();

    const onPeriodFromChange = (report2PeriodFrom?: Date) => {
      _store.update({ report2PeriodFrom, report2: undefined });
    };

    const onPeriodToChange = (report2PeriodTo?: Date) => {
      _store.update({ report2PeriodTo, report2: undefined });
    };

    const onMinChange = (report2Min?: number) => {
      _store.update({ report2Min, report2: undefined });
    };

    const onMaxChange = (report2Max?: number) => {
      _store.update({ report2Max, report2: undefined });
    };

    const onEvaluationStatusChange = (report2EvaluationStatus?: string) => {
      _store.update({ report2EvaluationStatus, report2: undefined });
    };

    const parseDateToTimestamp = (date: Date): number => {
      return DateService().parseDateToTimestamp(date);
    };

    const getReport2PDF = async () => {
      const {
        report2PeriodFrom,
        report2PeriodTo,
        report2Min,
        report2Max,
        report2EvaluationStatus
      } = _store.getState<TReport2Presenter>();
      loader.start("report2Loader");
      if (
        report2PeriodFrom &&
        report2PeriodTo &&
        report2Min !== undefined &&
        report2Max !== undefined
      ) {
        const report2 = await application.container
          .resolve<GetReport2DataInteractor>("getReport2Data")
          .execute(
            report2PeriodFrom,
            report2PeriodTo,
            report2Min,
            report2Max,
            report2EvaluationStatus
          );
        _store.update({ report2 });
      }
      loader.stop("report2Loader");
    };

    const getReport2XLSXLink = (): string => {
      const {
        report2PeriodFrom,
        report2PeriodTo,
        report2Min,
        report2Max,
        report2EvaluationStatus
      } = _store.getState<TReport2Presenter>();

      let periodFromTimestamp =
        report2PeriodFrom && parseDateToTimestamp(report2PeriodFrom);
      let periodToTimestamp =
        report2PeriodTo && parseDateToTimestamp(report2PeriodTo);

      return `/api/reports/report2/xlsx?periodFrom=${periodFromTimestamp}&periodTo=${periodToTimestamp}&min=${report2Min}&max=${report2Max}&evaluationStatus=${report2EvaluationStatus}`;
    };

    return {
      ...state,
      store: _store,
      loader,
      application: _application,
      translate,
      onPeriodFromChange,
      onPeriodToChange,
      onMinChange,
      onMaxChange,
      onEvaluationStatusChange,
      getReport2PDF,
      getReport2XLSXLink
    };
  },
  defaultState
);

export default Report2Presenter;
